import { useTranslation } from "react-i18next"
import { Text, View } from "react-native"

import { ChartData } from 'chart.js';
import 'chart.js/auto';
import { Doughnut } from "react-chartjs-2";

import { ReactComponent as MoreWhiteImg } from '../../../img/ico-prefix-more-white.svg';

import DashboardBox from "../../base/tamplate/DashboardBox"
import { FONT } from "../../../value/staticValues";
import { useEffect, useState } from "react";
import { percentValue } from "../../../common/util";

interface DoughnutChartBlueBoxProps {
    navigate: Function;
    url?: string;
    title: string;
    data: number;
    total: number;
    action?: string;
}
export default function DoughnutChartBlueBox(props: DoughnutChartBlueBoxProps) {
    const [percent, setPercent] = useState(0);

    useEffect(() => {
        setPercent(percentValue(props.data, props.total));
    }, [props]);


    const DoughnutChartOption = {
        cutout: '90%',
        plugins: {
            responsive: true,
            legend: {
                display: false
            },
            tooltip: {
                enabled: false
            }
        }
    }

    const vmChartData:ChartData<'doughnut'> = {
        labels: ["vm"],
        datasets: [
            {
                data: [percent, 100-percent],
                backgroundColor: [
                    "#ffffff",
                    "#ffffff30",
                ],
                borderWidth: 0,
                borderJoinStyle: "round",
            },
        ],
    }
    

    return (
        <DashboardBox style={{
            width: 330, height: 320,
            marginRight: 10,
            backgroundColor: "#4a77ff"
        }}>
            <View style={{flexDirection: "row", alignItems: "center", height: 20}}>
                <Text style={{
                    fontFamily: FONT.MEDIUM,
                    fontSize: 14,
                    lineHeight: 13,
                    color: "#fff"
                }}>
                    {props.title}
                </Text>
                {props.url ?
                    <MoreWhiteImg 
                        style={{marginLeft: "auto", cursor: "pointer"}}
                        onClick={() => {props.navigate(`${props.url}`)}}
                    />
                :null }
            </View>
            <View style={{flexDirection: "row", alignItems: "flex-end", marginTop: 20, marginLeft: 10}}>
                <Text style={{
                    fontFamily: FONT.BOLD,
                    fontSize: 32,
                    color: "#fff"
                }}>
                    {props.data}
                </Text>
                <Text style={{
                    marginLeft: 3, marginBottom: 7,
                    fontFamily: FONT.REGULAR,
                    fontSize: 10,
                    color: "#fff"
                }}>
                    {props.action ? props.action : "Available"}
                </Text>
            </View>
            <View style={{
                alignItems: "center", justifyContent: "center",
                marginLeft: 90,
            }}>
                <View style={{width: 130, height: 130,}}>
                    <Doughnut data={vmChartData} options={DoughnutChartOption}/>
                </View>
                <View style={{
                    alignItems:"center",
                    position:"absolute", 
                    top: 42, left: 78,
                }}>
                    <View style={{flexDirection: "row", alignItems: "flex-end"}}>
                        <Text style={{
                            fontFamily: FONT.BOLD,
                            fontSize: 32,
                            color: "#fff"
                        }}>
                            {percent}
                        </Text>
                        <Text style={{
                            marginLeft: 3, marginBottom: 5,
                            fontFamily: FONT.BOLD,
                            fontSize: 14,
                            color: "#fff"
                        }}>
                            %
                        </Text>
                    </View>
                </View>
            </View>
            <View style={{
                flexDirection: "row", alignItems: "center", justifyContent: "center",
                marginTop: "auto",
                width: 160, height: 35,
                borderRadius: 17.5,
                backgroundColor: "#fff"
            }}>
                <Text style={{
                    fontFamily: FONT.REGULAR,
                    fontSize: 12,
                    color: "#323ebd" 
                }}>
                    {props.action ? props.action : "Used"} {percent}%
                </Text>
                <Text style={{
                    marginLeft: 5,
                    fontFamily: FONT.REGULAR,
                    fontSize: 12,
                    color: "#333",
                }}>
                    / Total {props.total}
                </Text>
            </View>
        </DashboardBox>
    )
}